var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.tag,_vm._b({tag:"component",class:_setup.classes,attrs:{"aria-disabled":_vm.disabled || undefined},on:{"click":_setup.onClick}},'component',_setup.attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }